var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIc2H(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1153",
    "data-name": "Rectangle 1153",
    width: 36,
    height: 36,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_2_h",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(335.833 222.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_280-2",
    "data-name": "Group 280",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22018",
    "data-name": "Path 22018",
    d: "M16.78,33.015A16.236,16.236,0,1,1,33.017,16.777,16.255,16.255,0,0,1,16.78,33.015",
    transform: "translate(1.22 1.223)",
    fill: "#ffcc54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22019",
    "data-name": "Path 22019",
    d: "M2.738,18.975A16.222,16.222,0,0,1,29.221,6.4,16.227,16.227,0,1,0,6.392,29.221,16.151,16.151,0,0,1,2.738,18.975",
    transform: "translate(0.907 0.907)",
    fill: "#ffe8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22020",
    "data-name": "Path 22020",
    d: "M18,0A18,18,0,1,0,36,18,18.021,18.021,0,0,0,18,0m0,34.238A16.236,16.236,0,1,1,34.238,18,16.257,16.257,0,0,1,18,34.238",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22021",
    "data-name": "Path 22021",
    d: "M7.081,13.765l1.3-1.424A45.774,45.774,0,0,0,12,8.214,3.384,3.384,0,0,0,12.553,6.3,3.611,3.611,0,0,0,7.09,3.2,3.611,3.611,0,0,0,1.628,6.3,3.323,3.323,0,0,0,2.174,8.2,42.169,42.169,0,0,0,5.78,12.337ZM3.39,6.3a1.847,1.847,0,0,1,3.694,0H7.1a1.847,1.847,0,0,1,3.694,0,1.64,1.64,0,0,1-.289.992c-.231.374-3.421,3.863-3.421,3.863S3.927,7.694,3.68,7.288A1.59,1.59,0,0,1,3.39,6.3",
    transform: "translate(3.665 6.05)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22022",
    "data-name": "Path 22022",
    d: "M13.4,2.687a3.609,3.609,0,0,0-1.853.51A3.614,3.614,0,0,0,6.084,6.3a3.345,3.345,0,0,0,.549,1.912,42.738,42.738,0,0,0,3.6,4.129l1.3,1.427,1.3-1.424a45.221,45.221,0,0,0,3.619-4.126A3.384,3.384,0,0,0,17.012,6.3,3.613,3.613,0,0,0,13.4,2.687m1.557,4.6c-.231.374-3.421,3.863-3.421,3.863s-3.154-3.456-3.4-3.863A1.606,1.606,0,0,1,7.85,6.3a1.847,1.847,0,0,1,3.694,0h.013a1.847,1.847,0,1,1,3.694,0,1.64,1.64,0,0,1-.289.992",
    transform: "translate(13.698 6.05)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22023",
    "data-name": "Path 22023",
    d: "M2.292,7.794a11.624,11.624,0,0,0,22.438,0l.3-1.112H1.993Zm20.364.65a9.859,9.859,0,0,1-18.286,0Z",
    transform: "translate(4.487 15.044)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22024",
    "data-name": "Path 22024",
    d: "M2.17,5.076a1.847,1.847,0,0,1,3.694,0h.013a1.847,1.847,0,0,1,3.694,0,1.64,1.64,0,0,1-.289.992C9.05,6.441,5.86,9.93,5.86,9.93s-3.154-3.456-3.4-3.863a1.611,1.611,0,0,1-.289-.992",
    transform: "translate(4.886 7.27)",
    fill: "#ff4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22025",
    "data-name": "Path 22025",
    d: "M6.627,5.076a1.847,1.847,0,0,1,3.694,0h.013a1.847,1.847,0,1,1,3.694,0,1.64,1.64,0,0,1-.289.992c-.231.374-3.421,3.863-3.421,3.863s-3.154-3.456-3.4-3.863a1.59,1.59,0,0,1-.289-.992",
    transform: "translate(14.92 7.27)",
    fill: "#ff4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22026",
    "data-name": "Path 22026",
    d: "M21.01,7.224a9.859,9.859,0,0,1-18.286,0Z",
    transform: "translate(6.133 16.264)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc2H);
export default __webpack_public_path__ + "static/media/ic_2_h.9b6538abdb0256c15cb0b91dcdd13818.svg";
export { ForwardRef as ReactComponent };